"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_hook_form_1 = require("react-hook-form");
var types_1 = require("@/types");
var Styled = __importStar(require("./ApplicationFormTemplate.style"));
var components_1 = require("@/components");
var Input_component_1 = require("@/components/common/Input/Input.component");
var plus_20_svg_1 = __importDefault(require("@/assets/svg/plus-20.svg"));
var DEFAULT_QUESTION = {
    content: '',
    description: '',
    maxContentLength: null,
    questionType: types_1.QuestionKind.multiLineText,
    required: false,
};
var ApplicationFormTemplate = function () {
    var _a = (0, react_hook_form_1.useFormContext)(), register = _a.register, control = _a.control, clearErrors = _a.clearErrors;
    var _b = (0, react_hook_form_1.useFieldArray)({
        name: 'questions',
        control: control,
    }), fields = _b.fields, append = _b.append, remove = _b.remove;
    var handleRemoveItem = function (index) {
        remove(index);
        clearErrors('questions');
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.Content, { children: (0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": Input_component_1.InputSize.md, label: "\uC9C0\uC6D0\uC124\uBB38\uC9C0 \uBB38\uC11C\uBA85", placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694", required: true }, register('name', { required: true })), void 0) }, void 0), (0, jsx_runtime_1.jsxs)(Styled.QuestionContent, { children: [fields.map(function (field, index) { return ((0, jsx_runtime_1.jsx)(components_1.ApplicationFormItem, { index: index, handleRemoveItem: handleRemoveItem }, field.id)); }), (0, jsx_runtime_1.jsx)(Styled.Divider, {}, void 0), (0, jsx_runtime_1.jsxs)(Styled.AddButton, __assign({ type: "button", onClick: function () { return append(DEFAULT_QUESTION); } }, { children: [(0, jsx_runtime_1.jsx)(plus_20_svg_1.default, {}, void 0), (0, jsx_runtime_1.jsx)("span", { children: "\uC9C8\uBB38 \uCD94\uAC00" }, void 0)] }), void 0)] }, void 0)] }, void 0));
};
exports.default = ApplicationFormTemplate;
